import { vRdxUserInfo } from "../../Redux/roStore";
import { VitualBin_WMSVitualBinAttribute_GETROW } from "../../Server/ApiV2";
export const GetAttributes = async (
  setSummaryLocation,
  setSummaryTransType
) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  var vAttributeObj = {
    userCd: vRdxUserInfoObj.UserID,
  };
  const vDCRequestTransAttributes =
    await VitualBin_WMSVitualBinAttribute_GETROW(vAttributeObj);
  if (vDCRequestTransAttributes?.status === 200) {
    setSummaryLocation(vDCRequestTransAttributes?.data?.ResultSet?.Loc);
    setSummaryTransType(vDCRequestTransAttributes?.data?.ResultSet?.TaxType);
    return vDCRequestTransAttributes?.data?.ResultSet;
  } else {
    return [];
  }
};
